import * as React from "react";

function CatFoodBev(props) {
  return (
    <svg
      id="prefix__Layer_2"
      data-name="Layer 2"
      width="2em"
      height="2em"
      viewBox="0 0 128 128"
      {...props}
    >
      <defs>
        <style>{".prefix__cls-2{stroke-width:0;fill:#1a1a1a}"}</style>
      </defs>
      <g id="prefix__Layer_1-2" data-name="Layer 1">
        <path
          className="prefix__cls-2"
          d="M87.153 32.783H18.026c-4.15 0-7.526-3.377-7.526-7.527v-4.23c0-4.15 3.376-7.526 7.526-7.526h69.127c4.15 0 7.527 3.377 7.527 7.526v4.23c0 4.15-3.376 7.527-7.527 7.527zM18.026 18.5a2.53 2.53 0 00-2.526 2.526v4.23a2.53 2.53 0 002.526 2.527h69.127a2.53 2.53 0 002.527-2.527v-4.23a2.53 2.53 0 00-2.527-2.526H18.026z"
        />
        <path
          className="prefix__cls-2"
          d="M77.12 114.5H27.983c-7.402 0-13.424-6.022-13.424-13.425V30.283a2.5 2.5 0 012.5-2.5h70.986a2.5 2.5 0 012.5 2.5v70.792c0 7.403-6.023 13.425-13.425 13.425zM19.56 32.783v68.292c0 4.646 3.779 8.425 8.424 8.425H77.12c4.646 0 8.425-3.78 8.425-8.425V32.783H19.559z"
        />
        <path
          className="prefix__cls-2"
          d="M104.581 102.591H87.946a2.5 2.5 0 01-2.5-2.5V86.906a2.5 2.5 0 012.5-2.5h9.673c1.649 0 2.99-1.387 2.99-3.092V58.88c0-1.706-1.341-3.093-2.99-3.093h-9.673a2.5 2.5 0 01-2.5-2.5V40.104a2.5 2.5 0 012.5-2.5h16.635c7.123 0 12.919 5.884 12.919 13.117v38.753c0 7.232-5.796 13.117-12.919 13.117zm-14.135-5h14.135c4.366 0 7.919-3.642 7.919-8.117V50.72c0-4.476-3.553-8.117-7.919-8.117H90.446v8.184h7.173c4.405 0 7.99 3.63 7.99 8.093v22.433c0 4.462-3.585 8.092-7.99 8.092h-7.173v8.185z"
        />
        <path strokeWidth={0} fill="none" d="M0 0h128v128H0z" />
      </g>
    </svg>
  );
}

const MemoCatFoodBev = React.memo(CatFoodBev);
export default MemoCatFoodBev;
